var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 223,
    width: 30,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-998 -223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4937 3.02083C8.1574 3.02083 3.02083 8.1574 3.02083 14.4937 3.02083 20.8299 8.1574 25.9665 14.4937 25.9665 20.8299 25.9665 25.9665 20.8299 25.9665 14.4937 25.9665 14.4934 25.9665 14.4931 25.9665 14.4928 25.9687 8.15915 20.836 3.02301 14.5024 3.02083 14.4995 3.02083 14.4966 3.02083 14.4937 3.02083ZM17.2728 15.0416C15.6013 16.7101 13.9197 18.3935 12.228 20.0916 10.7905 18.6472 9.34957 17.2063 7.90522 15.7688L9.34948 14.3245 12.228 17.203C13.6255 15.7855 15.0151 14.3779 16.3968 12.9802 17.7776 11.5828 18.5416 10.8327 19.9738 9.44856 20.0139 9.40839 20.0571 9.36851 20.1039 9.32773 20.1493 9.28924 20.1899 9.24544 20.2248 9.19723L21.6893 10.6415C19.9883 12.3332 18.9443 13.3723 17.2725 15.0407Z",
    fill: "#006450",
    transform: "matrix(1.03448 0 0 1 998 223)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApproved);
export default __webpack_public_path__ + "static/media/IconApproved.3d6a6207a5d2460c7b92092e328ed30e.svg";
export { ForwardRef as ReactComponent };